import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { CommandNames, UserCommands } from '@common/types/permissions';
import { userPermissionCommandsSelector } from '../store/selectors';


export const useHasRequiredCommands = (commands: CommandNames | CommandNames[]) => {
  const requiredCommands = Array.isArray(commands) ? commands : [commands];
  const userCommands = useSelector(userPermissionCommandsSelector) as UserCommands;
  return requiredCommands.every(command => !!userCommands[command]);
};

type RequiresCommandsProps = {
  children: ReactNode,
  commands: CommandNames | CommandNames[],
  otherwise?: ReactNode | (() => ReactNode),
}

const renderProp = (prop: ReactNode | (() => ReactNode)) => {
  if (typeof prop === 'function') {
    return prop();
  }
  return (<> { prop ?? null } </>);
};

export const RequiresCommands: React.FC<RequiresCommandsProps> = (props: RequiresCommandsProps) => {
  const hasAccess = useHasRequiredCommands(props.commands);

  if (!hasAccess) {
    return renderProp(props.otherwise);
  }

  return (
    <>
      { props.children }
    </>
  );
};
